type AuthInstructionListProps = {
  items: string[]
}

export function AuthInstructionList({ items }: AuthInstructionListProps) {
  return (
    <ol className="m-0 mt-5 flex w-[min(100%,31.25rem)] list-none flex-col gap-3 p-0 text-left max-md:w-full">
      {items.map((item, index) => (
        <li className="grid grid-cols-[2rem_1fr] items-start gap-3.5 max-md:gap-3" key={item}>
          <span
            className="inline-flex h-[1.875rem] w-[1.875rem] items-center justify-center rounded-full bg-brand-primary text-base leading-none font-bold text-text-inverse"
            aria-hidden="true"
          >
            {index + 1}
          </span>
          <span className="m-0 text-[0.875rem] leading-[1.45] text-[#2b3340] max-md:text-[0.9375rem]">
            {item}
          </span>
        </li>
      ))}
    </ol>
  )
}
